import { Button } from "@progress/kendo-react-buttons";
import { Card, GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import React from "react";
import IconButton from "../../components/common/IconButton";
import { MdDelete } from "react-icons/md";
import {
  Field,
  FieldArray,
  FieldArrayRenderProps,
} from "@progress/kendo-react-form";
import {
  requiredValidator,
  skipValidator,
} from "../../components/formFields/CommonValidator";
import { closeDialog, openDialog } from "../../components/dialog/dialogSlice";
import AppDialog, { DialogCloseButton } from "../../components/dialog/Dialog";
import { Typography } from "@progress/kendo-react-common";
import {
  setOrderImageViewPayload,
  setProcessDetailDeleteIndex,
} from "./orderSlice";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import FormDatePicker from "../../components/formFields/FormDateField";
import FormSelectionField from "../../components/formFields/FormSelectionField";

import FormNumericTextField from "../../components/formFields/FormNumericTextField";
import FormTextArea from "../../components/formFields/FormTextArea";
import { findProductImageByProcess } from "../item/services/item.services";
import { FaEye } from "react-icons/fa";
import SizeDetailArray from "./SizeDetailArray";
import { PROCESS_ID } from "../../_contstants/common";
import { findAllActiveKarigar } from "../karigar/services/karigar.services";

const ProcessDetailArray = (fieldArrayRenderProps: FieldArrayRenderProps) => {
  const dispatch = useAppDispatch();
  const ProcessDeleteIndex = useAppSelector(
    (state) => state.order.ProcessDeleteIndex,
  );
  const karigarList = useAppSelector((state) => state.karigar.KarigarList);
  const processList = useAppSelector((state) => state.Process.ProcessList);
  // const ImageDetails = useAppSelector((state) => state.item.ImageList);
  const dialogName = useAppSelector((state) => state.dialog.dialogName);

  const handleDeleteAction = React.useCallback(
    (index: number) => {
      fieldArrayRenderProps.onRemove({ index: index });
      dispatch(closeDialog());
      dispatch(setProcessDetailDeleteIndex(-1));
    },
    [fieldArrayRenderProps],
  );

  const pushElementInarray = React.useCallback(() => {
    fieldArrayRenderProps.onPush({
      value: {
        process_id: null,
        karigar_id: null,
        image_id: null,
        given_date: "",
        receive_date: "",
        duration_days: null,
        description: "",
        estimated_weight: null,
      },
    });
  }, [fieldArrayRenderProps]);

  const handleOpenDeleteDialog = (index: any) => {
    dispatch(openDialog("orderDeleteDialog"));
    dispatch(setProcessDetailDeleteIndex(index));
  };

  const handleviewImage = async (process_id: any) => {
    const itemID = fieldArrayRenderProps.formRenderProps.valueGetter("item_id");
    if (process_id && itemID) {
      const payload = {
        item_id: itemID,
        process_id: process_id,
      };
      dispatch(setOrderImageViewPayload(payload));
      const res = await dispatch(findProductImageByProcess(payload));
      if (res.meta.requestStatus === "fulfilled") {
        fieldArrayRenderProps.formRenderProps.onChange("Images", {
          value: JSON.parse(JSON.stringify(res.payload)),
        });
        dispatch(openDialog("ImagesViewByProcessDialog"));
      } else {
        fieldArrayRenderProps.formRenderProps.onChange("Images", {
          value: [],
        });
        dispatch(openDialog("ImagesViewByProcessDialog"));
      }
    }
  };

  return (
    <GridLayout cols={[{ width: "100%" }]}>
      {!fieldArrayRenderProps.value ? pushElementInarray() : null}
      {dialogName === "orderDeleteDialog" && (
        <AppDialog>
          <>
            <Typography.h5>{"Delete Process Data"}</Typography.h5>
            <GridLayout>
              <GridLayoutItem>
                <Typography.p>
                  Are you sure you want to delete this?
                </Typography.p>
              </GridLayoutItem>
              <GridLayoutItem
                style={{
                  display: "flex",
                  justifyContent: "end",
                }}
              >
                <DialogCloseButton themeColor="error" />
                <Button
                  fillMode={"solid"}
                  themeColor={"error"}
                  onClick={() => handleDeleteAction(ProcessDeleteIndex)}
                  type="button"
                >
                  Delete
                </Button>
              </GridLayoutItem>
            </GridLayout>
          </>
        </AppDialog>
      )}
      {fieldArrayRenderProps.value &&
        fieldArrayRenderProps.value.length > 0 &&
        fieldArrayRenderProps.value.map((process_data: any, index: number) => (
          <GridLayoutItem key={index}>
            <Card className="fieldarray-card">
              <GridLayout
                style={{ marginRight: 40 }}
                gap={{ rows: 0, cols: 10 }}
                cols={[
                  { width: "16.55%" },
                  { width: "16.55%" },
                  { width: "16.55%" },
                  { width: "16.55%" },
                  { width: "16.55%" },
                  { width: "16.55%" },
                ]}
              >
                <GridLayoutItem
                  colSpan={6}
                  style={{
                    textAlign: "right",
                  }}
                >
                  <IconButton
                    onClick={() => handleOpenDeleteDialog(index)}
                    disabled={fieldArrayRenderProps.value.length === 1}
                    themeColor={"error"}
                    size={"small"}
                    fillMode={"solid"}
                    type="button"
                    style={{ height: 24, width: 24 }}
                  >
                    <MdDelete
                      className="absolute-position"
                      style={{ fontSize: "16px" }}
                    />
                  </IconButton>
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    name={`processdetails.${index}.process_id`}
                    label="Process Name"
                    placeholder="Select Process"
                    component={FormSelectionField}
                    validator={requiredValidator}
                    astrike={true}
                    options={processList
                      ?.filter(
                        (p: any) =>
                          !fieldArrayRenderProps.value
                            ?.map((item: any) => item?.process_id)
                            ?.includes(p.ID) ||
                          p.ID ===
                            fieldArrayRenderProps.value[index]?.process_id,
                      )
                      ?.map((process: any) => {
                        return {
                          value: process.ID,
                          label: process.process_name,
                        };
                      })}
                  />
                </GridLayoutItem>
                {fieldArrayRenderProps.formRenderProps.valueGetter(
                  `processdetails.${index}.process_id`,
                ) !== PROCESS_ID?.ready && (
                  <>
                    {" "}
                    <GridLayoutItem>
                      <Field
                        name={`processdetails.${index}.karigar_id`}
                        label="Karigar Name"
                        placeholder="Select Karigar"
                        dispatcherFunction={findAllActiveKarigar}
                        isAddNew={true}
                        addNewLink="karigar/create"
                        component={FormSelectionField}
                        validator={requiredValidator}
                        astrike={true}
                        options={karigarList
                          ?.filter((e: any) =>
                            e?.karigar_process
                              ?.map((item: any) => item?.process_id)
                              .includes(
                                fieldArrayRenderProps?.value[index]?.process_id,
                              ),
                          )
                          ?.map((karigar: any) => {
                            return {
                              value: karigar.id,
                              label:
                                karigar.karigar_nick_name ||
                                karigar.karigar_name,
                            };
                          })}
                      />
                    </GridLayoutItem>
                    <GridLayoutItem>
                      <Field
                        name={`processdetails.${index}.estimated_weight`}
                        label={
                          fieldArrayRenderProps.formRenderProps.valueGetter(
                            `processdetails.${index}.process_id`,
                          ) === PROCESS_ID?.jadai
                            ? `Kundan Weight (gm)`
                            : "Process Weight (gm)"
                        }
                        placeholder="0.000"
                        format="n3"
                        type="number"
                        component={FormNumericTextField}
                        validator={
                          fieldArrayRenderProps.formRenderProps.valueGetter(
                            `processdetails.${index}.process_id`,
                          ) === PROCESS_ID?.bandhai ||
                          fieldArrayRenderProps.formRenderProps.valueGetter(
                            `processdetails.${index}.process_id`,
                          ) === PROCESS_ID?.palish ||
                          fieldArrayRenderProps.formRenderProps.valueGetter(
                            `processdetails.${index}.process_id`,
                          ) === PROCESS_ID?.mina ||
                          fieldArrayRenderProps.formRenderProps.valueGetter(
                            `processdetails.${index}.process_id`,
                          ) === PROCESS_ID?.dull
                            ? skipValidator
                            : requiredValidator
                        }
                        astrike={
                          fieldArrayRenderProps.formRenderProps.valueGetter(
                            `processdetails.${index}.process_id`,
                          ) === PROCESS_ID?.bandhai ||
                          fieldArrayRenderProps.formRenderProps.valueGetter(
                            `processdetails.${index}.process_id`,
                          ) === PROCESS_ID?.palish ||
                          fieldArrayRenderProps.formRenderProps.valueGetter(
                            `processdetails.${index}.process_id`,
                          ) === PROCESS_ID?.mina ||
                          fieldArrayRenderProps.formRenderProps.valueGetter(
                            `processdetails.${index}.process_id`,
                          ) === PROCESS_ID?.dull
                            ? false
                            : true
                        }
                      />
                    </GridLayoutItem>
                    <GridLayoutItem colSpan={3} rowSpan={2}>
                      <Field
                        name={`processdetails.${index}.description`}
                        label="Description"
                        component={FormTextArea}
                      />
                    </GridLayoutItem>
                    <GridLayoutItem>
                      <Field
                        name={`processdetails.${index}.given_date`}
                        label="Approx work Start Date"
                        placeholder="day/month/year"
                        format={"dd/MM/yyyy"}
                        component={FormDatePicker}
                        validator={requiredValidator}
                        astrike={true}
                      />
                    </GridLayoutItem>
                    <GridLayoutItem>
                      <Field
                        name={`processdetails.${index}.duration_days`}
                        label="Duration days"
                        placeholder="Duration days"
                        min={0}
                        component={FormNumericTextField}
                        type="number"
                      />
                    </GridLayoutItem>
                    <GridLayoutItem>
                      <Field
                        name={`processdetails.${index}.receive_date`}
                        label="Received Date"
                        placeholder="day/month/year"
                        format={"dd/MM/yyyy"}
                        component={FormDatePicker}
                        disabled
                        validator={requiredValidator}
                        astrike={true}
                      />
                    </GridLayoutItem>
                  </>
                )}
                <GridLayoutItem
                  style={{
                    marginTop: 40,
                  }}
                >
                  <Button
                    type="button"
                    themeColor={"success"}
                    onClick={() => handleviewImage(process_data.process_id)}
                    fillMode={"solid"}
                  >
                    <FaEye style={{ fontSize: 20 }} /> View Process Images
                  </Button>
                </GridLayoutItem>

                {fieldArrayRenderProps.formRenderProps.valueGetter(
                  `processdetails.${index}.process_id`,
                ) !== PROCESS_ID?.ready && (
                  <GridLayoutItem
                    colSpan={6}
                    style={{
                      marginTop: "10px",
                      border: "1px dotted gray",
                      borderRadius: "8px",
                      padding: "10px",
                    }}
                  >
                    <Typography.h5 style={{ margin: 0 }}>
                      Size Details List
                    </Typography.h5>
                    <FieldArray
                      formRenderProps={fieldArrayRenderProps.formRenderProps}
                      component={SizeDetailArray}
                      name={`processdetails.${index}.sizedetails`}
                    />
                  </GridLayoutItem>
                )}
              </GridLayout>
            </Card>
          </GridLayoutItem>
        ))}
      <GridLayoutItem style={{ marginBottom: 10, textAlign: "left" }}>
        <Button
          fillMode={"solid"}
          themeColor={"primary"}
          disabled={processList?.length === fieldArrayRenderProps.value?.length}
          onClick={pushElementInarray}
          type="button"
        >
          Add Process Data
        </Button>
      </GridLayoutItem>
    </GridLayout>
  );
};

export default ProcessDetailArray;
